import { Component, Input } from '@angular/core';
import { OgcFilterableDataSource } from '../../datasource';

@Component({
  selector: 'igo-ogc-filterable-form',
  template: require('./ogc-filterable-form.component.html'),
  styles: [require('./ogc-filterable-form.component.styl')]
})
export class OgcFilterableFormComponent {

  @Input()
  get datasource(): OgcFilterableDataSource { return this._dataSource; }
  set datasource(value: OgcFilterableDataSource) {
    this._dataSource = value;
  }
  private _dataSource: OgcFilterableDataSource;

  constructor() {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/filter/ogc-filterable-form/ogc-filterable-form.component.ts